

const BrandStory = () => {
    return (
        <section class="cards-section">
        <div class="container">
            <h2 class="section-title">Brand Story</h2>
            <p className="main-description">
              <strong>Bella Vega</strong> creates elegant, functional handbags for modern women. Inspired by grace and confidence, our designs blend timeless style with everyday practicality.
              <br/><br/>
            The name <strong>“Bella”,</strong> meaning beautiful, reflects timeless elegance, while <strong>“Vega”,</strong> inspired by the brightest star in the sky, represents confidence, ambition, and individuality. Together, Bella Vega stands for <strong>beautiful strength</strong> — a woman who shines in her own way.
            <br/><br/>We focus on <strong>quality, comfort, and contemporary design,</strong> ensuring our bags are not only stylish but also practical for real life.
             </p>    
         </div>
    </section> 
    );
}

export default BrandStory;